export function isPdfUrl(url: string): boolean {
  const path = url.split("?")[0];
  return /\.pdf$/i.test(path);
}
